export default __webpack_public_path__ + "static/media/top_quote.2a8bb2aa.svg";